import {Component, inject, HostListener, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {User} from '../../services/user';
import {signOut} from 'aws-amplify/auth';

@Component({
  selector: 'app-menu',
  imports: [],
  templateUrl: './menu.html',
  styleUrl: './menu.scss',
})
export class Menu implements OnInit {
  userService = inject(User);
  private router = inject(Router);

  isDropdownOpen = false;
  appVersion = '';

  async ngOnInit() {
    try {
      const { getVersion } = await import('@tauri-apps/api/app');
      this.appVersion = await getVersion();
    } catch {
      this.appVersion = 'dev';
    }
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  // Fermer le dropdown quand on clique en dehors
  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('app-menu')) {
      this.isDropdownOpen = false;
    }
  }

  getInitials(): string {
    const info = this.userService.userInfo();
    if (!info) return '?';

    const firstInitial = info.first_name?.charAt(0).toUpperCase() || '';
    const lastInitial = info.last_name?.charAt(0).toUpperCase() || '';

    return firstInitial + lastInitial || '?';
  }

  goToSettings() {
    this.isDropdownOpen = false;
    this.router.navigate(['/profile/account']);
  }

  goToAdmin() {
    this.isDropdownOpen = false;
    this.router.navigate(['/admin']);
  }

  async logout() {
    try {
      this.isDropdownOpen = false;
      await this.userService.signOut(); // ← Utilise le service
      window.location.href = '/auth/login';
    } catch (error) {
      console.error('Error logging out:', error);
    }
  }
}
